import { useQuery } from '@tanstack/react-query'
import type { AuditLogResponseDto } from '@lunary/api-client'
import { api } from '../../shared/api/client'
import { addDays, moscowToday } from '../../shared/lib/moscow-date'
import type { AuditFilter } from './filters'

export const AUDIT_LOG_KEY = ['admin-audit-log'] as const
export const PAGE_SIZE = 50

export function useAuditLog(filter: AuditFilter, offset: number, enabled: boolean) {
  return useQuery({
    queryKey: [...AUDIT_LOG_KEY, filter, offset],
    queryFn: () =>
      api.get<AuditLogResponseDto>('/admin/audit-log', {
        query: {
          kind: filter.kind || undefined,
          actor_id: filter.actorId || undefined,
          entity_type: filter.section || undefined,
          from: filter.days ? addDays(moscowToday(), 1 - filter.days) : undefined,
          q: filter.q.trim() || undefined,
          limit: PAGE_SIZE,
          offset,
        },
      }),
    enabled,
    retry: false,
  })
}
